import { fetchAuthSession } from "aws-amplify/auth";
import type { AuthSession } from "aws-amplify/auth";
import { S3Client } from "@aws-sdk/client-s3";

type SessionCredentials = NonNullable<AuthSession["credentials"]>;

/**
 * Narrow a session's credentials to the ones an S3 client is built from.
 */
export function s3ClientCredentials(
  credentials: SessionCredentials | undefined,
): Pick<
  SessionCredentials,
  "accessKeyId" | "secretAccessKey" | "sessionToken"
> {
  if (!credentials) {
    throw new Error(
      "No AWS credentials are available for the current session.",
    );
  }
  return {
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
  };
}

/** Build an S3 client scoped to the current user's role credentials. */
export async function createS3Client(region: string): Promise<S3Client> {
  const { credentials } = await fetchAuthSession();
  return new S3Client({
    region,
    credentials: s3ClientCredentials(credentials),
  });
}
